import React, { Component } from "react";
import "./App.css";
import { Chart } from "react-charts";
import CountyPopulation from "./countyPopulation";
import axios from "axios";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import StateToCounty from "./stateToCounty";
import _ from "lodash";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      county: "San Francisco",
      usState: "California",
      /*
        Example format of selectedCovidData
        {
          California: {
            "San Francisco": {
              date: [],
              cases: [],
              deaths: [],
              newCases: [],
            }
          }
        }
         */
      selectedCovidData: {
        SampleState: {
          SampleCounty: {
            date: [1584057600000, 1584057700000],
            cases: [10000, 20000],
            deaths: [10000, 20000],
            newCases: [10000, 20000],
            population: 800000,
            percentOfPopulation: "2.5",
          },
        },
      },
      fullCovidData: "",
    };
  }

  componentDidMount = async () => {
    this.setState({
      isLoading: true,
    });

    const fullCovidData = (
      await axios.get(
        "https://raw.githubusercontent.com/nytimes/covid-19-data/master/us-counties.csv"
      )
    ).data;

    this.setState({ fullCovidData, isLoading: false });
  };

  setSelectedCovidData = async () => {
    const date = [];
    const cases = [];
    const deaths = [];
    const newCases = [];

    let previousCases = 0;
    this.state.fullCovidData.split("\n").forEach((line, index) => {
      const parsedLine = line.split(",");
      if (
        index > 0 &&
        this.state.usState === parsedLine[2] &&
        this.state.county === parsedLine[1]
      ) {
        const currentCases = parseInt(parsedLine[4]);
        date.push(new Date(parsedLine[0]).getTime());
        cases.push(currentCases);
        deaths.push(parseInt(parsedLine[5]));
        newCases.push(currentCases - previousCases);

        previousCases = currentCases;
      }
    });

    const population = CountyPopulation[this.state.usState][this.state.county];

    const latestConfirmedCases = cases[cases.length - 1];
    const percentOfPopulation = (
      (latestConfirmedCases / population) *
      100
    ).toFixed(2);

    const specificStateCounty = {
      date,
      cases,
      deaths,
      newCases,
      population,
      percentOfPopulation,
    };

    const selectedCovidData = this.state.selectedCovidData;
    delete selectedCovidData.SampleState;
    _.set(
      selectedCovidData,
      `${this.state.usState}.${this.state.county}`,
      specificStateCounty
    );

    this.setState({ selectedCovidData });
  };

  render() {
    return (
      <div className="home-page">
        <h2> Covid 19 Dashboard</h2>
        <b>Select the state and county you would like to get statistics for</b>
        {this.renderInput()}
        {this.state.isLoading ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <span>
            {"SampleState" in this.state.selectedCovidData ? (
              <h4>Sample County, Sample State</h4>
            ) : (
              ""
            )}
            {this.renderChart("cases", "Confirmed Cases (Log Scale)", "log")}
            {this.renderChart("cases", "Confirmed Cases", "linear")}
            {this.renderChart("newCases", "Daily New Cases", "linear")}
            {this.renderChart("deaths", "Deaths", "linear")}
            <div id="data-table">{this.renderTable()}</div>
            {this.renderFooter()}
          </span>
        )}
      </div>
    );
  }

  renderInput() {
    return (
      <div id="input-form">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.setSelectedCovidData();
          }}
        >
          <Form.Label>
            State:
            <Form.Group>
              <Form.Control
                as="select"
                onChange={(e) =>
                  // When selecting a new state, set the default county for that state to be the first county in the list
                  this.setState({
                    usState: e.target.value,
                    county: StateToCounty[e.target.value][0],
                  })
                }
                value={this.state.usState}
              >
                {this.renderChoicesForState()}
                });
              </Form.Control>
            </Form.Group>
          </Form.Label>
          <br />
          <Form.Label>
            County:
            <Form.Control
              as="select"
              onChange={(e) => this.setState({ county: e.target.value })}
              value={this.state.county}
            >
              {this.renderChoicesForCounty()}
              });
            </Form.Control>
          </Form.Label>
          <br />
          <Button onClick={this.setSelectedCovidData}>Add to Graph</Button>
          <Button
            id="remove-from-graph"
            variant="danger"
            onClick={() => {
              const newSelectedCovidData = this.state.selectedCovidData;
              delete newSelectedCovidData[this.state.usState][
                this.state.county
              ];
              this.setState({ selectedCovidData: newSelectedCovidData });
            }}
          >
            Remove from Graph
          </Button>
        </Form>
      </div>
    );
  }

  renderChoicesForState = () => {
    return Object.keys(StateToCounty)
      .sort()
      .map((state) => {
        return <option value={state}>{state}</option>;
      });
  };

  renderChoicesForCounty = () => {
    return StateToCounty[this.state.usState].map((county) => {
      return <option value={county}>{county}</option>;
    });
  };

  renderChart(dataField, name, chartType) {
    let data = [];
    Object.keys(this.state.selectedCovidData).forEach((usState) => {
      Object.keys(this.state.selectedCovidData[usState]).forEach((county) => {
        let arrayOfTimeToValue = [];
        for (
          let i = 0;
          i < this.state.selectedCovidData[usState][county].date.length;
          i++
        ) {
          arrayOfTimeToValue.push([
            parseInt(this.state.selectedCovidData[usState][county].date[i]),
            parseInt(
              this.state.selectedCovidData[usState][county][dataField][i]
            ),
          ]);
        }
        data.push({
          label: `${county}, ${usState}`,
          data: arrayOfTimeToValue,
        });
      });
    });

    const axes = [
      { primary: true, type: "time", position: "bottom" },
      { type: chartType, position: "left" },
    ];

    const chart = (
      // A react-chart hyper-responsively and continuusly fills the available
      // space of its parent element automatically
      <span
        style={{
          width: "500px",
          height: "300px",
        }}
      >
        <Chart data={data} axes={axes} tooltip />
      </span>
    );
    return (
      <span className="chart-table-parent">
        <p>{name}</p>
        {chart}
      </span>
    );
  }

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  renderTable() {
    const tables = [];
    Object.keys(this.state.selectedCovidData).forEach((usState) => {
      Object.keys(this.state.selectedCovidData[usState]).forEach((county) => {
        const latestConfirmedCases = this.state.selectedCovidData[usState][
          county
        ].cases[
          Object.keys(this.state.selectedCovidData[usState][county].cases)
            .length - 1
        ];
        tables.push(
          <span className="chart-table-parent">
            <b>
              {county}, {usState}
            </b>
            <br />
            <b>Population:</b>{" "}
            {this.numberWithCommas(
              this.state.selectedCovidData[usState][county].population
            )}
            <br />
            <b> Confirmed Cases as Percent of Population: </b>
            {this.state.selectedCovidData[usState][county].percentOfPopulation}%
            <Table striped bordered hover className="smaller-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Cases</th>
                  <th>Daily New Cases</th>
                  <th>Deaths</th>
                </tr>
              </thead>
              <tbody>{this.renderRows(usState, county)}</tbody>
            </Table>
          </span>
        );
      });
    });
    return tables;
  }

  renderRows = (usState, county) => {
    const fiveHoursInMilliseconds = 1000 * 60 * 60 * 5;
    const rows = Object.keys(
      this.state.selectedCovidData[usState][county].date
    ).map((key) => {
      return (
        <tr>
          <td>
            {new Date(
              parseFloat(
                this.state.selectedCovidData[usState][county].date[key]
              ) + fiveHoursInMilliseconds
            ).toLocaleDateString()}
          </td>
          <td>
            {this.numberWithCommas(
              this.state.selectedCovidData[usState][county].cases[key]
            )}
          </td>
          <td>
            {this.numberWithCommas(
              this.state.selectedCovidData[usState][county].newCases[key]
            )}
          </td>
          <td>
            {this.numberWithCommas(
              this.state.selectedCovidData[usState][county].deaths[key]
            )}
          </td>
        </tr>
      );
    });

    const subsetOfRows = rows.reverse().slice(0, 15);
    return subsetOfRows;
  };

  renderFooter() {
    return (
      <div id="footer">
        <span className="item">
          <a
            href="https://github.com/nytimes/covid-19-data"
            target="_blank"
            rel="noopener noreferrer"
          >
            Data Source
          </a>
        </span>
        <span className="item">
          <a
            href="http://www.timpnguyen.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact
          </a>
        </span>
      </div>
    );
  }
}
